'use strict';

angular.module('imagetrend.components')
    .directive('hlpButton', ['Format', 'Permissions', '$rootScope', function (Format, Permissions, $rootScope) {
        return {
            restrict: 'AE',
            scope: {
                id: '@?',
                label: '@?',
                title: '@?',
                classes: '@?',
                loading: '=?',
                loadingText: '@?',
                permission: '@?',
                permissionState: '@?',
                isDisabled: '=?'
            },
            replace: true,
            transclude: true,
            require: '^hlpButtonGroup',
            templateUrl: 'templates/button/button.html',
            link: function (scope, elem, attrs, ctrl) {

                if (!attrs.id) { attrs.id = 'button'; }
                if (!attrs.label) { attrs.label = 'Button'; }
                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.classes && attrs.classes != "") { attrs.classes = 'edit'; }
                if (!attrs.loadingText) { if (attrs.loading) { attrs.loadingText = Format.label(attrs.loading) } else { attrs.loadingText = 'Loading'; } }
                if (!attrs.permissionState && $rootScope.$state != null && $rootScope.$state.current != null) { attrs.permissionState = $rootScope.$state.current.name; }

                if (attrs.permission != null && attrs.permissionState != null) {
                    Permissions[attrs.permission](attrs.permissionState).then(function (access) {
                        scope.hasPermission = access;
                    });
                }
                else {
                    scope.hasPermission = true;
                }

                scope.$watch('loading', function (loading) {
                    if (loading != null) {
                        ctrl.setLoader(loading, scope.classes, scope.loadingText);
                    }
                });

                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).off();
                        angular.element(elem).remove();
                        elem = null;
                    }
                });
            }
        };
    }])

;